import React, { MouseEvent } from 'react'
import { Select2 } from '@blueprintjs/select'
import { Checkbox, MenuItem, Position } from '@blueprintjs/core'
import { IUIButtonProps } from '@ui/buttons/Button'
import { Button, Flex } from '@ui'
import { get } from 'lodash'

export type Size = 'Small' | 'Small-med' | 'Medium' | 'Large'

interface SizeSelectWrapperProps {
  value: React.ReactNode
  btnText?: string
  itemDisabled?: (item: Size) => boolean
  onChange: (item: Size) => void
  buttonProps?: IUIButtonProps
  multi?: boolean
}

const SizeSelect = Select2<Size>

export default function SizeSelectWrapper({
  value,
  btnText,
  itemDisabled,
  onChange,
  buttonProps,
  multi,
}: SizeSelectWrapperProps) {
  const options: Size[] = ['Small', 'Small-med', 'Medium', 'Large']

  return (
    <SizeSelect
      popoverProps={{ minimal: true, position: Position.BOTTOM }}
      filterable={false}
      items={options}
      itemRenderer={(size, { handleClick, modifiers }) => (
        <MenuItem
          key={`size-${size}`}
          active={modifiers.active}
          onClick={(e: MouseEvent<HTMLElement>) => {
            if (multi) {
              e.preventDefault()
              onChange(size)
              return
            }
            handleClick(e)
          }}
          text={
            <Flex align="center">
              {multi && <Checkbox checked={itemDisabled && itemDisabled(size)} />}
              {size}
            </Flex>
          }
        />
      )}
      onItemSelect={onChange}
    >
      <Button
        {...buttonProps}
        text={value ? value : btnText || 'Select'}
        rightIconName={!get(buttonProps, 'iconName') && !value ? 'chevron-down' : undefined}
      />
    </SizeSelect>
  )
}
